'use client';

import Markdown from 'react-markdown';

import {
    Align,
    FlexBox,
    GapSize,
    IconName,
    Image,
    List,
    ListItem,
    Text,
    TextLevels,
    TrilogyColor,
    TypographyAlign,
    TypographyBold,
} from '@bytel/trilogy-react';

import { FaiType, FaiTypeNugget } from '@app-types/plan';

import { getSpeedInfos } from '@helpers/speed-infos';

interface NuggetsListProps {
    plan?: FaiType;
    nuggets?: FaiTypeNugget[];
    displaySpeed?: boolean;
    boxBackground?: TrilogyColor;
}

//TODO: improve this component to have only one source of data
export function NuggetsList({ plan, nuggets, displaySpeed = true }: Readonly<NuggetsListProps>) {
    const { upRates, downRates, speedWording } = plan ? getSpeedInfos(plan) : {};

    const getNuggets = (plan?: FaiType, nuggets?: FaiTypeNugget[]): FaiTypeNugget[] => {
        const returnedNuggets = plan?.nuggets ?? nuggets ?? [];

        if (!displaySpeed) {
            return returnedNuggets.filter((nug) => !nug.showSpeed);
        }

        return returnedNuggets;
    };

    const nug = getNuggets(plan, nuggets).sort((a, b) => {
        const positionA = a.position ?? Number.MAX_SAFE_INTEGER;
        const positionB = b.position ?? Number.MAX_SAFE_INTEGER;
        return positionA - positionB;
    });

    if (!nug.length) {
        return null;
    }

    return (
        <List>
            {nug.map((nugget) => (
                <ListItem key={nugget.label} iconName={nugget.image ? undefined : (nugget.icon as IconName)}>
                    <FlexBox align={Align.CENTER} gap={GapSize.TWO}>
                        {nugget.image && <Image src={nugget.image} className='icon' alt='' />}
                        <Text level={TextLevels.TWO} marginless typo={TypographyAlign.TEXT_LEFT}>
                            <Markdown
                                components={{
                                    p: 'span',
                                }}
                            >
                                {nugget.label}
                            </Markdown>
                            {nugget.showSpeed && (
                                <>
                                    <br />
                                    {speedWording && ' ' + speedWording}
                                    {plan && (
                                        <Text
                                            markup='span'
                                            typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}
                                            accessibilityLabel={`${downRates} en débit descendant et ${upRates} en débit montant`}
                                        >
                                            {' '}
                                            ↓&nbsp;{downRates?.replace(' ', '\u00A0')}&nbsp;&nbsp;↑&nbsp;
                                            {upRates?.replace(' ', '\u00A0')}
                                        </Text>
                                    )}
                                </>
                            )}
                        </Text>
                    </FlexBox>
                </ListItem>
            ))}
        </List>
    );
}
